import { gql, ApolloError, useApolloClient } from '@apollo/client';
import { useState, useEffect, useCallback } from 'react';

const GET_MLB_MATCHUPS = gql`
  query GetMlbMatchups {
    mlbMatchups {
        team
        oTeam
        date
        startTime
        site
        line
        oLine
        wins
        losses
        oWins
        oLosses
        total
        streak
        oStreak
        runLineStreak
        oRunLineStreak
        ouStreak
        oOuStreak
        oRunLine
        runLine
        oRunLineOdds
        runLineOdds
        activeTrends {
            isAtsTrend
            isSuTrend
            isOuTrend
            isDefaultTrend
            isDefaultUserTrend
            atsWins
            atsLosses
            overs
            unders
            wins
            losses
            oPoints
            points
            trend
            trendDescription
            activeGames {
              activeDate
              activeOTeam
              activeTeam
            }
        }
    }
  }
`;

export const useGetMlbMatchups = (
    skip: boolean = false,
    isLoggedIn: boolean = false
) => {
    const client = useApolloClient();

    const [data, setData] = useState<any>(null);
    const [loading, setLoading] = useState(!skip);
    const [error, setError] = useState<ApolloError | null>(null);

    const fetchData = useCallback(async () => {
        setLoading(true);
        setError(null);

        try {
            const response = await client.query({
                query: GET_MLB_MATCHUPS,
                variables: {},
                fetchPolicy: 'network-only',
            });

            setData(response.data);
            return response;
        } catch (err) {
            setError(err as ApolloError);
            throw err;
        } finally {
            setLoading(false);
        }
    }, [client]);

    useEffect(() => {
        if (!skip) {
            fetchData();
        }
    }, [fetchData, skip]);

    useEffect(() => {
        if (isLoggedIn && !skip) {
            fetchData();
        }
    }, [isLoggedIn, skip, fetchData]);

    return { data, loading, error, refetch: fetchData };
};